// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__YV9xa","notes":"Notes_notes__3HH09","note":"Notes_note__2_m4V","markdown":"Notes_markdown__3nh2i"};